/* eslint-disable no-duplicate-imports */
import * as React from 'react';

export interface IRememberMeCheckbox {
    id?: string;
    name?: string;
    className: string;
    label?: string;
    ariaLabel: string;
}

const RememberMeCheckbox: React.FC<IRememberMeCheckbox> = ({ id, className, label, name, ariaLabel }) => {
    return (
        <div className={className}>
            <input id={id} className={className} aria-label={ariaLabel} name={name} type='checkbox'></input>
            <label htmlFor={id}>{label}</label>
        </div>
    );
};

export default RememberMeCheckbox;
